/* Applier for the badge_pill experiment: sale badge as dollars ("Save $28") vs
   percent ("20% OFF"). The server renders dollar-primary (it cannot know the
   visitor); this normalizes every badge to the assigned arm. Assignment, stamping
   and exposure live in the framework (ab-assign + ab.js). Ending the test =
   enabled=false on the metaobject (nothing here runs), then delete this file. */
(function () {
  if (!(window.wooj && window.wooj.ab)) return;

  function money(cents) {
    if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, theme.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function normalize(arm, root) {
    var wraps = (root || document).querySelectorAll('.auto-discount-price[data-auto-discount="true"]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var badge = w.querySelector('.auto-discount-badge');
      if (!badge) continue;
      var pct = parseInt(w.getAttribute('data-auto-discount-percentage'), 10) || 0;
      var orig = parseInt(w.getAttribute('data-original-price'), 10) || 0;
      var disc = parseInt(w.getAttribute('data-discounted-price'), 10) || 0;
      if (arm === 'percent' && pct > 0) {
        var pctText = pct + '% OFF';
        if (badge.textContent !== pctText) badge.textContent = pctText;
        badge.classList.remove('auto-discount-badge--savings');
      } else if (arm === 'dollar' && orig - disc > 0) {
        var usdText = 'Save ' + money(orig - disc);
        if (badge.textContent !== usdText) badge.textContent = usdText;
        badge.classList.add('auto-discount-badge--savings');
      }
    }
  }

  window.wooj.ab.on('badge_pill', function (arm) {
    window.__abBadgePill = arm; // legacy readers
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; normalize(arm, document); });
    }
    function start() {
      normalize(arm, document);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      window.addEventListener('cc-variant-updated', schedule);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  });
})();
